import ProjectScenes from "../../features/graph/ProjectScenes";
import { useParams } from "react-router";
import Node from "../../features/graph/components/NodeForm";
import ProjectSidebar from "../../common/components/Sidebar/ProjectSidebar";
import { useAppSelector } from "src/common/state/hooks";
import { getIsLoading } from "../../features/graph/state/graphuSlice";
import { getCurrentProject } from "src/features/projects/state/projectsSlice";

export const ProjectGraph = () => {
  const isGraphLoading = useAppSelector(getIsLoading);

  return (
    <div>
      {!isGraphLoading && (
        <div className="flex w-[10%] justify-center">
          <ProjectSidebar />
        </div>
      )}
      <ProjectScenes />
    </div>
  );
};

export const NodeScreen = () => {
  const { nodeId, contentType } = useParams();

  const currentProject = useAppSelector(getCurrentProject);

  if (nodeId) {
    if (
      currentProject.is_template === true &&
      currentProject.project_tags?.[0]?.slug !== "custom-templates"
    ) {
      return <Node nodeId={nodeId} contentType={contentType as string} mode="view" />;
    }
    return <Node nodeId={nodeId} contentType={contentType as string} mode="edit" />;
  } else {
    return <>Node not found</>;
  }
};
